import ctl from '@netlify/classnames-template-literals';

export const sectionStyle = ctl(`
  grid 
  gap-x-4 
  gap-y-2
  grid-cols-2
`);
